export default __webpack_public_path__ + "static/media/finished.d9b5e50a.png";